
//解决方案
import Panel from './panel.vue';
export default {
    Panel
}